var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.96,46.21c8.34,0,15.11-6.77,15.11-15.11s-6.77-15.11-15.11-15.11-15.11,6.77-15.11,15.11,6.77,15.11,15.11,15.11ZM49.96,23.55c4.17,0,7.55,3.38,7.55,7.55s-3.38,7.55-7.55,7.55-7.55-3.38-7.55-7.55,3.38-7.55,7.55-7.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.43,52.55c6.69,0,12.13-5.44,12.13-12.13s-5.44-12.13-12.13-12.13-12.13,5.44-12.13,12.13,5.44,12.13,12.13,12.13ZM74.97,40.42c0-2.46,2-4.46,4.46-4.46s4.46,2,4.46,4.46-2,4.46-4.46,4.46-4.46-2-4.46-4.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.73,54.59h-16.59c-.4,0-.79.03-1.18.06-2.46-1.73-5.44-2.75-8.67-2.75h-22.66c-3.22,0-6.21,1.02-8.66,2.74-.36-.03-.73-.06-1.1-.06H12.27c-6.69,0-12.13,5.44-12.13,12.13v9.68c0,2.11,1.72,3.83,3.83,3.83s3.83-1.72,3.83-3.83v-9.68c0-2.46,2-4.46,4.46-4.46h12.03c-.5,1.5-.78,3.09-.78,4.76v13.22c0,2.09,1.69,3.78,3.78,3.78s3.78-1.69,3.78-3.78v-13.22c0-4.17,3.38-7.55,7.55-7.55h22.66c4.17,0,7.55,3.38,7.55,7.55v13.22c0,2.09,1.69,3.78,3.78,3.78s3.78-1.69,3.78-3.78v-13.22c0-1.66-.28-3.26-.78-4.76h12.11c2.46,0,4.46,2,4.46,4.46v9.68c0,2.11,1.72,3.83,3.83,3.83s3.83-1.72,3.83-3.83v-9.68c0-6.69-5.44-12.13-12.13-12.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57,52.55c6.69,0,12.13-5.44,12.13-12.13s-5.44-12.13-12.13-12.13-12.13,5.44-12.13,12.13,5.44,12.13,12.13,12.13ZM16.11,40.42c0-2.46,2-4.46,4.46-4.46s4.46,2,4.46,4.46-2,4.46-4.46,4.46-4.46-2-4.46-4.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeGroup);
export default __webpack_public_path__ + "static/media/acae_group.48fa9391.svg";
export { ForwardRef as ReactComponent };